import React, { useState } from "react";
import MyNavbar from "../../../components/customer/myNavbar/MyNavbar";
import Footer from "../../../components/customer/footer/Footer";
import HeroSection from "./HeroSection";
import AllTreatments from "../treatments/AllTreatments";
import EstaticeLaser from "./EstaticeLaser";
import WhyUs from "./WhyUs";
import Deals from "./Deals";
import Testimonials from "./Testimonials";
import BlogSection from "./BlogSection";
import Booking from "./Booking";
import AllBlogs from "../blogScreen/AllBlogs";
import DealsSection from "../deals/DealsSection";
import { Import } from "lucide-react";
const Home = () => {
    const [activeFilter, setActiveFilter] = useState("All");
    return(  
         <>
          <MyNavbar/>
          <HeroSection/>
          <AllTreatments screen={"home"} activeFilter={activeFilter} />
          <EstaticeLaser/>
           <DealsSection screen={"deal"}/>
          <WhyUs/>
         
          {/* <Deals/> */}
          <Testimonials/>
          <AllBlogs screen={"blog"}/>
          {/* <BlogSection/> */}
          <Booking/>
          <Footer/>
        
         </>
  );
};

export default Home;
